import { render, staticRenderFns } from "./FormularioDataExecucao.vue?vue&type=template&id=dbfb2c70&"
import script from "./FormularioDataExecucao.vue?vue&type=script&lang=ts&"
export * from "./FormularioDataExecucao.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports